import type { Dict } from '../utils'

import { createContext } from '../utils'

const [LinkProvider, useLinkContext] = createContext<Dict>({ isOptional: true })

export { LinkProvider, useLinkContext }
